import { Link } from "react-router-dom"

function SidebarItem1({ icon, label, isActive = false, link, onClick }) {
    return (
      <Link to={link} className={`dropdown_item ${isActive ? 'active' : ''}`} onClick={onClick}>
        <span>{icon}</span>
        <span>{label}</span>
      </Link>
    )
  }
  
  export default SidebarItem1